// import { formatTimestampHuman } from "../date-utils";
export const productTypeFields = [{
        name: "description",
        title: "Descrizione",
        render: (record) => record.description
    }, {
        name: "storageTemperature",
        title: "Temperatura",
        render: (record) => record.storageTemperature
    }, {
        name: "bestBeforeDays",
        title: "Giorni Scadenza",
        render: (record) => record.bestBeforeDays
    }];
